<template>
  <div class="employeesCreate">
    <CloseModalBtn :closeModal="closeModal" />
    <div class="step" v-if="step === 1">
      <h5>
        {{
          userTypeSubscriber
            ? localStorage.translations.pages['sales_project']['planned_resources-subscribers'][
                'title'
              ]
            : localStorage.translations.pages['setting-users']['dialog-assign_role'][
                'vyberite-polzovatelya'
              ]
        }}
      </h5>
      <div class="step_list">
        <label class="step_list_item" v-for="item in userReady" :key="item.id">
          <div class="step_list_item_text">
            <p class="name">
              {{ item.first_name + ' ' + item.last_name }}
            </p>
            <p class="email">{{ item.email }}</p>
          </div>
          <div class="step_list_item_button">
            <input type="radio" :value="item" v-model="selectedUser" />
            <span class="checkmark"><Check /></span>
          </div>
        </label>
      </div>
      <button class="next" @click="step = 2" :class="{ disabled: !selectedUser }">
        +
        {{
          localStorage.translations.pages['setting-users']['dialog-assign_role-buttons']['vybrat']
        }}
      </button>
    </div>
    <div class="step two" v-else>
      <h5>
        {{
          localStorage.translations.pages['setting-users']['dialog-assign_role']['naznachit-rol']
        }}
      </h5>
      <div class="box">
        <div class="box_text">
          <p class="box_text_name">
            {{ selectedUser.first_name + ' ' + selectedUser.last_name }}
          </p>
          <p class="box_text_email">{{ selectedUser.email }}</p>
        </div>
        <div class="box_role">
          <v-label>
            {{
              localStorage.translations.pages['setting-users']['dialog-assign_role-labels']['rol']
            }}
          </v-label>
          <v-select
            outlined
            menu-props="offset-y"
            class="selectCustom"
            :items="rolesAllData"
            item-text="role_name"
            item-value="role_name"
            :placeholder="localStorage.translations.pages.common.text.not_assigned"
            v-model="roleSelect"
            append-icon="fas fa-angle-down"
            hide-details
          ></v-select>
        </div>
      </div>
      <button class="next" :class="{ disabled: !roleSelect }" @click="assignRoleToUser">
        +
        {{
          localStorage.translations.pages['setting-users']['dialog-assign_role-buttons'][
            'naznachit'
          ]
        }}
      </button>
    </div>
  </div>
</template>

<script>
import Check from 'components/icons/radio/Check'
import CloseModalBtn from 'components/CloseModalBtn'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserAssingRolesModalList',
  components: { CloseModalBtn, Check },
  props: { closeModal: Function, onDownloadPageData: Function },
  data() {
    return {
      selectedUser: null,
      roleSelect: null,
      step: 1,
    }
  },
  created() {
    if (!this.userTypeSubscriber) {
      this.onCommonUserGridAll()
    } else {
      this.onCommonUserSubscribersAll()
    }

    this.roleList()
  },
  watch: {
    selectedUser() {
      if (this.selectedUser.roles.length) {
        this.roleSelect = this.selectedUser.roles[0].role_name
      }
    },
  },
  computed: {
    ...mapGetters('commonUser', ['commonUserGridAll', 'commonUserSubscribersAll']),
    userTypeSubscriber() {
      return this.$route.name === 'SettingUsers-subscribers'
    },
    rolesAllData() {
      return this.$store.getters['commonRole/rolesAllData']
    },

    userReady() {
      const data = this[this.userTypeSubscriber ? 'commonUserSubscribersAll' : 'commonUserGridAll']
      let result = null
      if (data && data.length) {
        result = data.filter((i) => i.roles.length === 0)
      }
      return result
    },
  },
  methods: {
    ...mapActions('commonUser', ['onCommonUserGridAll', 'onCommonUserSubscribersAll']),
    roleList() {
      this.$store.dispatch('commonRole/listOfRolesAll')
    },
    async assignRoleToUser() {
      await this.$store
        .dispatch('commonRole/assingRoleToUser', {
          user_id: this.selectedUser.id,
          roles: [this.roleSelect],
        })
        .then((response) => {
          if (response) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },
              { root: true },
            )
            this.onDownloadPageData()
            this.closeModal()
          }
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.employeesCreate {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  position: relative;
  .step {
    h5 {
      padding: 30px 30px 10px;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      text-align: center;
      color: #2c2c2c;
    }
    &_list {
      height: 568px;
      overflow-y: auto;
      display: grid;
      grid-template-rows: repeat(auto-fill, minmax(70px, 1fr));
      border-top: 1px solid #696969;
      border-bottom: 1px solid #696969;
      scrollbar-color: #b4b4b4;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 8px;
        background: lightgray;
      }

      &::-webkit-scrollbar-thumb {
        background: #b4b4b4;
      }
      &_item {
        display: grid;
        padding: 18px 30px;
        grid-template-columns: auto max-content;
        align-items: center;
        cursor: pointer;
        transition: 0.2s;
        border-bottom: 1px solid #dbdbdb;
        &_text {
          display: grid;
          grid-template-rows: max-content;
          grid-row-gap: 4px;
          justify-content: start;
          p {
            margin: 0;
            text-align: start;
            &.name {
              font-weight: normal;
              font-size: 14px;
              line-height: 16px;
              color: #52525f;
            }
            &.email {
              font-weight: normal;
              font-size: 12px;
              line-height: 14px;
              color: #277faf;
            }
          }
        }
        &_button {
          position: relative;

          input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            &:checked {
              ~ {
                .checkmark {
                  background-color: #277faf;
                  border: 2px solid #277faf;
                  svg {
                    display: block;
                  }
                }
              }
            }
          }
          .checkmark {
            width: 24px;
            height: 24px;
            border: 2px solid #2c2c2c;
            border-radius: 50%;
            display: grid;
            align-items: center;
            justify-content: center;
            svg {
              display: none;
            }
          }
        }
        &:hover {
          background: #277faf;
          .step_list_item_text {
            p {
              &.name {
                color: #ffffff;
              }
              &.email {
                color: #ffffff;
              }
            }
          }
          .step_list_item_button {
            .checkmark {
              border: 2px solid #ffffff;
            }
          }
          input {
            &:checked {
              ~ {
                :deep() .checkmark {
                  background-color: #ffffff;
                  border: 2px solid #ffffff;
                  svg {
                    display: block;
                    path {
                      stroke: #277faf;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .next {
      width: 100%;
      height: 55px;
      box-shadow: 0px 8px 16px rgba(67, 142, 184, 0.2);
      font-weight: 500;
      font-size: 15px;
      line-height: 16px;
      letter-spacing: 0.04em;
      color: #277faf;
      text-transform: uppercase;
      &:hover {
        background-color: #277faf;
        color: #ffffff;
      }
      &.disabled {
        user-select: none;
        pointer-events: none;
        color: #b4b4b4;
      }
    }
    &.two {
      h5 {
        padding: 30px;
      }
      .box {
        padding: 30px;
        border-top: 1px solid #696969;
        border-bottom: 1px solid #696969;
        display: grid;
        grid-row-gap: 30px;
        justify-content: center;
        justify-items: center;
        &_text {
          text-align: center;
          display: grid;
          grid-row-gap: 4px;
          p {
            margin: 0;
          }
          &_name {
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #52525f;
          }
          &_email {
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            color: #277faf;
          }
        }
        &_role {
          width: 250px;
          display: grid;
          row-gap: 10px;
        }
      }
    }
  }
}
</style>
